<template><section><h1>Calendar</h1>
<blockquote>
<p>日历</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>date</td>
<td style="text-align:left">日历当前选中的日期，请使用<code>v-model</code>获取及设置</td>
<td><code>Date</code></td>
<td>-</td>
</tr>
<tr>
<td>daterange</td>
<td style="text-align:left">是否开启范围模式</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>begin_date</td>
<td style="text-align:left">日历起始日期，<code>daterange = true</code>时有效，请设置<code>.sync</code></td>
<td><code>Date</code></td>
<td>-</td>
</tr>
<tr>
<td>end_date</td>
<td style="text-align:left">日历结束日期，<code>daterange = true</code>时有效，请设置<code>.sync</code></td>
<td><code>Date</code></td>
<td>-</td>
</tr>
<tr>
<td>type</td>
<td style="text-align:left">日历类型，可选值<code>day</code>/<code>month</code>/<code>year</code></td>
<td><code>String</code></td>
<td><code>day</code></td>
</tr>
<tr>
<td>filter</td>
<td style="text-align:left">过滤方法，具体看下方*</td>
<td><code>Function</code></td>
<td>-</td>
</tr>
<tr>
<td>one_calendar</td>
<td style="text-align:left">是否单个日历显示，<code>daterange = true</code>时有效，默认两个日历</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>is_inline</td>
<td style="text-align:left">是否行内显示</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
<tr>
<td>format</td>
<td style="text-align:left">格式化展示的值, 默认<code>yyyy-MM-dd</code></td>
<td><code>String</code></td>
<td>-</td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>事件</th>
<th style="text-align:left">说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change_date</td>
<td style="text-align:left">当日期改变时的回调</td>
<td><code>[ date &lt;Date:单选日期&gt;]</code>/<code>[ begin_date &lt;Date:日期&gt;, end_date &lt;Date:结束日期&gt;]</code></td>
</tr>
<tr>
<td>change_mode</td>
<td style="text-align:left">当模式改变时的回调</td>
<td><code>[ mode &lt;String:模式&gt;]</code></td>
</tr>
</tbody>
</table>
<pre><code class="language-js"><span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">filter</span> (<span class="hljs-params">date</span>) </span>{
  <span class="hljs-comment">// 返回 true 则可用，返回 false 则禁用</span>
  <span class="hljs-keyword">return</span> <span class="hljs-built_in">Boolean</span>
}
</code></pre>
<h2>Slot</h2>
<table>
<thead>
<tr>
<th>名字</th>
<th style="text-align:left">说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>day</td>
<td style="text-align:left">日期</td>
</tr>
<tr>
<td>month</td>
<td style="text-align:left">月份</td>
</tr>
<tr>
<td>year</td>
<td style="text-align:left">年份</td>
</tr>
<tr>
<td>display</td>
<td style="text-align:left">展示</td>
</tr>
</tbody>
</table>
<p><a href="https://vuefe.cn/v2/guide/components.html#%E4%BD%9C%E7%94%A8%E5%9F%9F%E6%8F%92%E6%A7%BD">#</a> 使用 具有特殊属性 <code>scope</code> 的 <code>&lt;template&gt;</code> 元素做插槽时，可在作用域中获取 <code>day</code>/<code>month</code>/<code>year</code>数据, <code>nextMonth</code>/<code>prevMonth</code>/<code>nextYear</code>/<code>prevYear</code>/.</p>
</section></template>

<script>
  import test from '@/pages/demo/Calendar.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-24.vue?70dd3e18